import { CountryDto } from '../commonTypes/country.types';
import { diContainer } from '../libs/container';
import { ApiBaseClass, IServiceHttp } from './ApiBase';
export namespace CountriesApiRequest {
    export interface GetAll {}
}

export namespace CountriesApiResponse {
    export interface GetAll {
        body: CountryDto[];
    }
}

export class CountriesApi {
    constructor(private readonly apiBase: ApiBaseClass) {}

    public getAll(rest: IServiceHttp<CountriesApiRequest.GetAll, CountriesApiResponse.GetAll>) {
        return this.apiBase.configure({
            ...rest,
            method: 'GET',
            url: 'org/v1/country',
            isAuthorized: false,
            invalidCacheTime: 0,
        });
    }
}

diContainer.bindAsDynamic(CountriesApi, c => new CountriesApi(c.get(ApiBaseClass)));
